import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { useStyles } from './ButtonPrimaryDarkStyles';
import clsx from 'clsx';

interface IButtonPrimaryDark extends ButtonProps {
  loading?: boolean;
  rootBtnClass: string;
  loadingBtnClass: string;
  loadingAnimationClass: string;
}

export const ButtonPrimaryDark: React.FC<IButtonPrimaryDark> = ({
  rootBtnClass,
  loadingBtnClass,
  loadingAnimationClass,
  disabled,
  className,
  loading,
  children,
  ...rest
}: IButtonPrimaryDark): JSX.Element => {
  const classes = useStyles();

  if (loading) {
    return (
      <Button className={clsx(rootBtnClass, className, loadingBtnClass)} {...rest} disabled>
        <div className={loadingAnimationClass}></div>
      </Button>
    );
  } else {
    return (
      <Button className={clsx(rootBtnClass, classes.btnPrimaryDark, className)} disabled={disabled} {...rest}>
        {children}
      </Button>
    );
  }
};

export default ButtonPrimaryDark;
